import { MAGNOLIA_NEXT_API_URL, NOT_FOUND_URL, PRODUCT } from "@/constants";
import logError from "@/utils/logger";

const fetchNotFoundContent = async () => {
  let pageJson;
  try {
    const fetchURL = `${MAGNOLIA_NEXT_API_URL}/${NOT_FOUND_URL}/${PRODUCT}/not-found`;
    const response = await fetch(fetchURL);
    if (!response.ok) {
      pageJson = {};
    }
    const res = await response.json();
    pageJson = res.data;
  } catch (e) {
    logError(e as Error, { location: "fetchNotfound.tsx" });
    pageJson = {};
  }

  return pageJson;
};

export default fetchNotFoundContent;
